import React from 'react';
import { useParams } from 'react-router-dom';
import { CertificateDesigner } from './AddCertificate';

/* ─── Route component: /edit-certificate/:certificateId ─────────────────────
   Reuses the same full-page designer as AddCertificate, but in edit mode:
   - Loads the template via GET /api/admission/certificate-template/<id>/
   - Saves via PUT (form-data) /api/admission/certificate-template/<id>/
     The PUT payload by default carries the template's already-saved
     organization + branch (captured from the GET response), so an update
     never moves the template to a different branch by accident. If the saved
     template has no org/branch, the global branch filter + stored user's
     organization are used as fallback.
   - Image uploads only replace files when a new File is chosen;
     otherwise the server keeps the existing images.
────────────────────────────────────────────────────────────────────────── */
export default function EditCertificate() {
  const { certificateId } = useParams();

  return <CertificateDesigner mode="edit" certificateId={certificateId} />;
}